module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "chapter",
    attrs: {
      "id": "ch01"
    }
  }, [_c('a', {
    attrs: {
      "id": "page07"
    }
  }, [_c('div', {
    staticClass: "chapterHead"
  }, [_c('h2', {
    staticClass: "chapterNumber",
    staticStyle: {
      "text-indent": "0%"
    }
  }, [_c('span', {
    staticClass: "bold"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Chapter One")])])])])]), _c('div', {
    staticClass: "chapterBody"
  }, [_c('a', {
    attrs: {
      "id": "page07"
    }
  }, [_c('p', {
    staticClass: "chapterDateline",
    staticStyle: {
      "text-indent": "0%"
    }
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Rome"), _c('br'), _vm._v(" 65 BC")])]), _vm._v(" "), _c('p', {
    staticClass: "chapterOpenerText",
    staticStyle: {
      "text-indent": "0%"
    }
  }, [_c('span', {
    staticClass: "chapterOpenerFirstLetters"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("W")])]), _vm._v("ho was that man? And, more importantly, why did she know him?")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Julia Antonia risked another look at the man standing in the portico of the baths. It was not his bronzed muscular legs emerging from his almost too-short tunic nor the breadth of his shoulders that captured her attention, but rather the planes of his shadowed face. She knew those features as intimately as she knew an old friend’s and yet, when she heard him speak to his companion, she knew she had never heard his voice before.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("His gaze caught hers and it seemed as if he could look into her soul. He arched an eyebrow and nodded. Did he recognise her as well? Her fingers pulled her russet shawl more firmly about her head and shoulders and smoothed the folds of her green wool gown, making sure she was dressed in a manner appropriate for a Roman matron.")])]), _c('a', {
    attrs: {
      "id": "page08"
    }
  }, [_c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Sabina Claudia, her stepmother, gave that high-pitched cackle she always used when she tore some unsuspecting matron’s reputation to shreds and threw the scraps into the swollen river of Roman gossip. Sabina’s friends leant forward, their shawls quivering, eager to hear the latest juicy morsel, crowding out Julia’s view of the stranger. When she had the time to glance back, the man had gone, vanishing into the busy marketplace as if he had never been there.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Where had she seen him before? His features were so familiar and yet she was positive she had never encountered him before. She’d have remembered that low rumble of a voice. The answer was on the tip of her tongue. She stared at where he had been, willing the answer to come or otherwise it would bother her for days.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("‘Where can that litter be? I told them I wanted to be picked up at the fifth hour, not at half past,’ Julia’s stepmother’s annoyed voice broke through Julia’s concentration. ‘You can’t get decent help these days for love or money.’")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Sabina’s harpies sighed in agreement.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("‘Shall I go and check? It sounds like a crowd has gathered up there.’ Julia pointed to one of the side streets. It would do no good to remind Sabina that her husband was using their one litter for court and had promised to send it when he could. ‘It could be held up. In any case, then we will know why the crowds are there.’")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("She hurried away, without waiting for an answer. No doubt, Sabina Claudia had turned back to her cronies with a sigh and the complaint: ‘Poor creature, with no tire-woman to do her bidding, but what can one expect if one chooses to divorce a senator?’ No doubt, the women would agree and it would signal another long gossip about Julia’s failings and the scandal she had caused.")])]), _c('a', {
    attrs: {
      "id": "page09"
    }
  }, [_c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Julia held her head higher and quickened her pace. She did not regret divorcing Lucius Gracchus with his three chins, flabby fingers that curled into hard fists and lightning-quick temper. The wonder was that she had endured it for three and a half years. Every night, she went down on her knees and thanked Minerva that she had finally had the courage to leave.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("‘Excuse me,’ she asked a porter balancing a basket of fish on his head, ‘do you know why the crowd has gathered?’")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("The porter’s eyes slid passed her and he moved on without answering. Julia wrinkled her nose, torn between discovering the reason for the gathering crowd and returning to the safety of the portico. The crowd was the most interesting thing to happen to her in days, other than catching sight of that mysterious man.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("‘Gladiators,’ came the answer from a smooth rich voice from behind her right shoulder.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Julia spun round and found herself staring at the man from the portico. Close up, she could see the way the fine white linen of his tunic strained against his massive chest, and the bulge of his arm muscles as if he spent hour after in the gymnasium or on the practice fields. If only her mind would remember. She tilted her head. ‘Gladiators?’")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("‘That crowd are waiting to see the gladiators arrive. Julius Caesar, in his capacity as Aedile in charge of all public entertainment, is assembling the largest troop of gladiators Rome has ever seen. He is offering the games in honour of his late father. Today is the day they start entering the city of Romulus.’")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page09"
    }
  }, [_vm._v("‘Is that so?’ Julia’s heart sank. She had forgotten today’s promised spectacle. The news would not improve Sabina’s temper. Her stepmother disapproved of the games and the time her father spent watching them. It was about the only ")]), _c('a', {
    attrs: {
      "id": "page10"
    }
  }, [_vm._v("thing she and Julia had some sort of mutual agreement on. ‘I had forgotten. Not everyone follows the games, you know. Is that why you are here?’")])]), _c('a', {
    attrs: {
      "id": "page10"
    }
  }, [_c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("‘In a manner of speaking.’ A smile tugged at the corners of his mouth. A twinkle shone in his eyes. ‘But I would rather speak about you. Why you are here—and why you followed me from the portico.’")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("‘I didn’t,’ Julia protested. ‘I wanted to see what the disturbance was.’")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("‘Ah, yes. It is all coincidence.’ He looped his thumbs through his belt. ‘You try to attract my attention, signalling with your eyes to meet out here and then you deny it ever happened. Bold but intriguing.’")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Julia gulped. Had her actions been misinterpreted? She had only wanted to know where they had met before and why she seemed to know him. She stared at her hands. Now was the perfect chance. Once she had worked out where she knew him from, then the rest could be dismissed with a laugh and shrug of her shoulders. It would do no good to deny her actions. She was finished with that sort of behaviour.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("‘Do I know you from somewhere?’ Julia asked in a rush before her nerve failed. She had to put her mind at rest. She fixed her gaze on the bright red awning of the market stall, rather than risking another glance upwards at his dark fringed eyes. ‘I saw you outside the baths and thought we had met somewhere before, but could not remember where.’")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("‘I’m Valens.’ The man gave a slight bow. ‘In the flesh—and you are?’")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page10"
    }
  }, [_vm._v("‘Julia Antonia. Should I know your name?’ Julia forced her lips to curve upwards and arched an eyebrow. ‘Perhaps you could give me more of a clue to your identity. After all, Rome ")]), _c('a', {
    attrs: {
      "id": "page11"
    }
  }, [_vm._v("is the largest city in the world and there are very few who can go by one name.’")])]), _c('a', {
    attrs: {
      "id": "page11"
    }
  }, [_c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("‘I’m Valens the Thracian,’ he said and shifted somewhat uncomfortably as if he were a child caught in the act of stealing honey cakes, instead of a hardened survivor of more than a dozen gladiatorial combats. This was not how the conversation was supposed to go, how he planned on it going when he heard her ask the porter the question. He had noticed her earlier and thought from her reaction that she had guessed who he was. His interest had been stirred when he thought that she had followed him after flirting with him with her eyes.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("‘If you are a gladiator, why are you here?’ Julia Antonia crossed her arms. ‘Why is no one crowding around you? Maybe you are one of the untried gladiators.’")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Valens rubbed the back of his neck. Having his identity as a gladiator questioned was a novelty. ‘I had business to conduct for the owner of my gladiatorial troop, arrangements about using the bathing facilities.’")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("‘And so…’")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Valens looked at the young woman standing before him with her face half-covered by a russet shawl and attempted to think of an answer, an explanation for his behaviour. Normally women were quivering puddles at his feet once they realised who he was, begging for some token for their husbands and sons or, worse, offering him their bed.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("‘Some say I’m one of the best gladiators in a generation or more,’ Valens said, choosing his words. He hated to brag, preferring to let the skill of his sword in the arena speak for itself, but this woman left him little choice. ‘Surely you’ve seen the posters. They are plastered all over Rome—from the Forum to the Circus Maximus. Figurines of me and the other gladiators are on sale from any street corner vendor.’")])]), _c('a', {
    attrs: {
      "id": "page12"
    }
  }, [_c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("He watched for the inevitable swoon. Nothing but a slight curve to her full lips. He waited. A tiny frown appeared between her eyebrows.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("‘Oh, that explains it. I had begun to wonder.’ Her voice held a note of relief. ‘I must have noticed the figurines. It all makes sense now. We have never met. How silly of me. I thought…it doesn’t matter what I had thought. Of course not. It had to have been the figurines. Funny, though, I never really look at them. It just goes to show that one notices more than one thinks.’")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Valens stared at her in disbelief. Who was this Julia Antonia? Why was it such a relief that she had noticed him from a figurine, rather than having actually met him? He should walk away, should never have engaged her in conversation. Yet, there was something about her, the tone of voice, the way she held her head. With her clear eyes and heart-shaped face, she possessed a classic beauty, not one derived from pots of paint and the skills of her make-up artist. And her figure, from what he could see of it through the layers she wore, had the curves of a woman. Layers his fingers itched to unwrap, to free her like a butterfly emerging from a cocoon for his eyes only, to see the beauty he felt positive was hidden underneath.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("As she gave a slight tap to her sandalled foot, he realised there was something more, a challenge to her eyes. She was treating him as a person. It had been a long time since anyone, let alone a woman of her social standing, had dared speak to him like a human being.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page12"
    }
  }, [_vm._v("For the past four and a half years, since winning his first bout as a gladiator, he had either been treated as a god worthy of simpering worship, or a slave beneath contempt. He was neither. He was a man, doing a job. And she was the first ")]), _c('a', {
    attrs: {
      "id": "page13"
    }
  }, [_vm._v("to treat him as such, to remind him that there was more to life than the arena.")])]), _c('a', {
    attrs: {
      "id": "page13"
    }
  }, [_c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Another cruel twist of the Fates’ thread, just as he had reached the pinnacle of his career—to remind him of what he had lost, what had been torn from his grip.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("‘I thought you’d recognised the badge on my cloak, there in the portico.’ Valens tried again. He held out the insignia, emblazoned gold against the deep blue wool, for her inspection.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("She examined the badge. ‘A lion with a spear. I’m sorry, it doesn’t mean anything to me.’")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("‘It is the symbol for the School of Strabo. One of the foremost gladiator schools in Italy.’")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Still that amused tolerant expression, but this time with a liquid laugh, a laugh that made him feel bathed in sunshine. Valens relaxed a little. Maybe now they could begin to break the impasse. He could retire from this battle with his honour intact. She would think he was more than a man beset by demons, given to accosting women. She’d understand him to be what he was—a gladiator who’d made an honest mistake. He was surprised that it mattered, but it did.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("‘Now I begin to understand. It starts to make some sort of strange sense.’ Julia forced her smile to brighten as her mind raced. It would have to happen to her. A gladiator, the nearest thing in Rome to a living god, thought she had flirted with him. For the time the gladiators fought, their names were on everyone’s lips, their pictures emblazoned on plates and cups and their images moulded into small statuettes that were avidly collected by the games’ many supporters.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page13"
    }
  }, [_vm._v("Without having to think hard, she knew a dozen women who would offer their best "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("stola t")]), _vm._v("o be in her sandals right now. But they weren’t here, she was. And she intended to teach this ")]), _c('a', {
    attrs: {
      "id": "page14"
    }
  }, [_vm._v("gladiator a lesson. Not every woman he locked eyes with wanted to arrange an illicit meeting. She felt rather foolish for not having realised where she knew his features from earlier. All this could have been avoided. Juno’s gown, what it must have looked like to him?")])]), _c('a', {
    attrs: {
      "id": "page14"
    }
  }, [_c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("‘What makes strange sense?’ he asked, crossing his arms, making the material strain even more across his chest.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("‘Why you might think women would arrange assignations with their eyes. I understand many women are mad about gladiators. But I have to disappoint you again. For the entire twenty-one years of my existence I have found it possible to restrain myself from such behaviour and have chosen to remain in ignorance about gladiatorial games and the merits of gladiators in general.’")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("He lifted an eyebrow as if he did not believe her.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("‘Not everybody does, you know.’ Julia gave a pointed cough. ‘I merely came out to discover where my stepmother’s litter was.’")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("‘You don’t follow the games?’ Valens’s eyes widened and he put a hand to his forehead. ‘I refuse to believe it.’")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("‘Is that some sort of crime?’ Julia asked, beginning to enjoy herself. It was liberating to be frank. His face showed his absolute amazement. He appeared to have shrunk slightly, to have become a man. ‘Where is it written that everyone must be passionate about the games?’")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("‘Not a crime,’ he said, running his hand through his thick dark hair. ‘By the gods, no, just a surprise. Rome is such a gladiatorial-mad city. It seems all the conversation revolves around the games.’")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page14"
    }
  }, [_vm._v("‘Does it, indeed? I had rather thought conversation in Rome revolved around the Senate or perchance the army and its recent victories over the pirates. There is life beyond the ")]), _c('a', {
    attrs: {
      "id": "page15"
    }
  }, [_vm._v("games. I, for one, have lived all my life in Rome and have never seen any need to visit the games.’")])]), _c('a', {
    attrs: {
      "id": "page15"
    }
  }, [_c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("A silence. Julia resisted the urge to clap her hands together in triumph. She had done it. She had emerged from the long shadows of her marriage and had answered back. He had no ready quip to shoot back at her. She had won. She had proven to herself that she was indeed the new Julia Antonia.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("‘They were light-hearted remarks. I meant no harm by them.’ His smile turned beguiling and her heart contracted. He touched her right elbow with feather-light fingers. ‘Forgive me?’")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("‘Apology accepted.’ She’d end the conversation here. On a high note. Before she melted from the heat of his charm. ‘Now, if you’ll excuse me, I need to see about getting home. Another conversation that will not involve gladiators.’")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("She stepped backwards and her sandal slipped, sending her to the ground and scattering her bathing things. Warm hands gripped her elbow and helped her to stand.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("‘Are you all right?’ His face showed concern, while his hands held her steady and for a breath she rested her head against his chest. ‘Your foot landed between two paving stones.’")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page15"
    }
  }, [_vm._v("‘I’m fine.’ Julia moved her arm and he released her. She dropped to her knees, starting to pick up her scattered belongings—her bath "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("strigil")]), _vm._v(", ivory comb and four carved hairpins. She jammed them back into her shoulder bag. Where was the fifth? She scanned the ground for the hairpin and her alabaster perfume flask. Her heart sank when she saw where the hairpin lay. Julia gingerly plucked it from the top of Valen’s sandal. She made a face. Why she had thought today would be different from any other day, she had no idea. Once again she had ruined a perfectly good exit. Try to teach a man a les")]), _c('a', {
    attrs: {
      "id": "page16"
    }
  }, [_vm._v("son and end up falling at his feet, literally falling. Without a doubt, it could only happen to her.")])]), _c('a', {
    attrs: {
      "id": "page16"
    }
  }, [_c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("She glanced over to the portico of the baths, but Sabina and her entourage had disappeared. The litter had probably arrived and her stepmother had left. Julia could already hear Sabina’s rising screech of a lecture when she did make it back to the villa. ‘I’ve lost my alabaster jar, but, other than that, I will survive.’")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("A small gasp of pain came from her throat as she put too much weight down on her ankle. Strong hands grabbed her arm and steadied her.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("‘You’ve hurt yourself. You’re limping.’")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Without waiting for an answer, Valens knelt down and wrapped his warm fingers around her ankle. Julia felt the warmth radiate up her leg. She should object, but the words refused to come. He pushed aside the cloth to reveal her sandal, and the reddened skin. His fingers hovered just at her ankle.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("‘Have you grazed your knee? Or is it just your foot?’")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("‘Not my knee, you stopped my fall,’ she stammered, remembering the feel of his chest against her hands.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("‘Yes, I remember.’ His gaze held hers, until she looked away, pretending a sudden interest in the wool merchant across the road, festooned in an array of brightly coloured cloth. ‘I’m not likely to forget. What I want to know is how badly you are hurt.’")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Julia’s heart turned over. She hated to think how long it had been since anyone had asked a question about her with care in their voice, much less touched her with gentle hands. This stranger asked after her health, with more warmth in his voice than Lucius had had in all the time they were married. She bit her lip and tried to swallow the lump in her throat.")])]), _c('a', {
    attrs: {
      "id": "page17"
    }
  }, [_c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("‘I twisted my ankle in the fall. Nothing to worry about.’ Her words tumbled out. Her eyes were drawn to the way his black hair curled on his neck just above his tunic as he bent over her foot. Giving her head a quick shake, she attempted to recapture her wit. ‘I’m sure I can cope. I wouldn’t want to deprive any woman who might be looking to arrange an assignation with you…’")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Valens kept his hand on her leg. Instead of letting go, he touched the area above and below her ankle with careful fingers, turning her foot this way and that, but never enough to cause real pain. Julia again felt the heat from his hand course up her leg. It terrified her and excited her.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Now she started to understand why the poets went on about instant attraction. She had never felt this warm melting for anyone before, and she knew little to nothing about this man, this gladiator. She stared at him, wondering how a turned ankle could make her so light-headed, breathless.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("‘I think I’ve had my quota for the day,’ he said, answering her joke with one of his own. ‘Besides, I wouldn’t have wanted to miss the opportunity of holding such a pretty ankle.’")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("The intimacy of his smile made her knees weaken and her hands itch to bury themselves in his hair. She had to take control of the situation or her actions would echo her thoughts, and she’d be little better than the women who stood around the gladiators’ entrance after a match, hoping for a glimpse of their hero. And swooning with great long sighs whenever any gladiator appeared.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Julia withdrew her foot from his hand.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("‘You are an idle flatterer. It is the first time in my life anyone has praised my ankles.’")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page17"
    }
  }, [_vm._v("‘Maybe it is time somebody did.’ He laughed and then his ")]), _c('a', {
    attrs: {
      "id": "page18"
    }
  }, [_vm._v("face sobered. ‘How bad is your ankle? Is the pain better or worse than when you first turned it?’")])]), _c('a', {
    attrs: {
      "id": "page18"
    }
  }, [_c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("‘It is nothing. I’ll shake it off in a few steps.’")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("She forced herself to ignore the pain as she rotated it, but the world blurred in a haze. She could do this. She was strong enough to withstand it. She forced her back straighter.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("‘It looks more than a twisted ankle to me. You can barely put weight on your right foot.’ Valens stood up, then reached out and lifted her chin. ‘Your lips are white from pain.’")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Julia’s breath caught in her throat. For a heartbeat, she could only stare at him, watching the rise and fall of his chest. His eyes seemed to swallow her. Her lips ached, parted of their own volition. He might kiss her…in public. The thought acted like a plunge into the cold-water pool at the baths, bringing her to her senses. She ducked her head, hiding her face deeper in her shawl and made one last attempt to keep her dignity.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("‘The pain is lessening.’ Julia took a step backwards and forced a smile on her face. She was a Roman matron, not a courtesan or a prostitute. Roman matrons had pure thoughts and a steady heartbeat. Keeping those thoughts uppermost, she folded her arms across her breasts. ‘The Forum is only a few streets away, after that it is not too far to Subura and home. It should hold out if I go slowly.’")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("She shut her eyes and tried to believe her words, tried not to count the number of steps it would take.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("‘What, and collapse on someone else? Subura is at least a mile from the Forum. And how far do you think you’ll get on your own, limping like that? You’ll be a target for every thief and cutpurse in the city,’ he said gravely.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Julia’s heart started to race faster and she clenched her fists to prevent herself from throwing them around his neck. She had help. She wasn’t alone.")])]), _c('a', {
    attrs: {
      "id": "page19"
    }
  }, [_c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("‘Julia, Julia, what in the name of the Good Goddess do you think you are doing?’ Sabina said, rushing up to her and grabbing her arm. Julia put out her hands to keep her balance. She felt Valens’s hand on the small of her back steady her. ‘The litter is here at last. Your father did remember after all.’")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("‘I…that is…’ Julia gulped. Sabina would have to appear, just as things were starting to become interesting.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("‘It came just after you went on your little walk. I have been searching for you everywhere!’ Sabina said, her voice rising in a piercing shriek. ‘It is bad enough that your father uses our one and only litter on the day I promised Livia I’d meet her at the baths, but you have to go off on some excursion of your own, just when we need to leave. If you won’t think of your own reputation, Julia, at least think about your family’s.’")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("‘I hurt my ankle and this gentleman has been helping me.’ Julia said, hoping her stepmother had not seen Valens’s hands on her leg. ‘You were obviously too busy to notice.’")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Julia watched Sabina’s eyes narrow as she regarded Valens, taking in the short tunic and the expensive cloak slung around his shoulders. Julia resisted the temptation to bite her nails.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("‘And you are?’ Sabina’s voice could have been chipped out of marble.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("‘Valens the gladiator at your service, ma’am.’ He gave a slight bow. ‘Rescuing fair maids in distress is a speciality.’")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("‘Julia, how could you? A gladiator,’ Sabina whispered furiously. ‘You promised—no more scandals. You’re not to give Mettalius any excuse to wriggle out of your wedding.’")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page19"
    }
  }, [_vm._v("‘Since when is falling a scandal?’ Julia stared at Sabina. An edited version of the truth was in order if she was avoid a lecture—something that skirted around Valens’s early banter and her replies to it. At Sabina’s narrowed eyes, Julia wid")]), _c('a', {
    attrs: {
      "id": "page20"
    }
  }, [_vm._v("ened hers. ‘It’s the truth. Valens kindly helped when others would have ignored me.’")])]), _c('a', {
    attrs: {
      "id": "page20"
    }
  }, [_c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("‘Please spare me.’ Sabina cast her eyes heavenwards, before turning towards Valens. She made a shooing motion with her hands. ‘It’s all right now. My maid and I can see Julia Antonia safely home. We do have a litter. Thank you for helping.’")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("There was a pause as Valens lifted his eyebrow and Julia watched her stepmother’s cheek colour.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("‘Would you like something for your trouble?’ Sabina asked through firmly pursed lips. ‘Galla—’")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("‘Keep your money,’ Valens said stiffly. ‘A simple act of kindness, such as I would do for any.’")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Julia wished the ground would open and swallow her. How could her stepmother be that rude?")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("‘Thank you. You were very kind. I appreciate it.’")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("He caught her hand and held it, encasing it in his warmth. Their eyes locked and Julia felt her heart begin to race again.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("‘Julia, we have to go. Are you aware of how many things I have to do today?’")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Julia started and withdrew her hand, scorched from the heat.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("‘It was my pleasure. What else are gladiators good for?’ Valens gave a lopsided smile. ‘If I come across your flask, I’ll try to return it to you.’")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Julia returned his smile, before she limped off with Sabina and her maid flanking her on either side. One bright spot in her otherwise gloomy day. As if on cue, the rain started drizzling down, sending the market stall owners scurrying to close up and cover their goods.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("She ignored Sabina’s litany of complaint and concentrated on thinking about Valens’s smile, indulging in a daydream of how he’d find her perfume flask and use it as an excuse to see her again.")])])]), _c('a', {
    attrs: {
      "id": "page20"
    }
  })]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "page20"
    }
  })])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-19b395da","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/9781459229921_ch01.vue
// module id = 78
// module chunks = 0